// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap);"]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto+Mono:400,500,700&display=swap);"]);
// Module
exports.push([module.id, "html {\n  font-size: 100%;\n}\n\nbody {\n  font-family: \"Helvetica\", \"Roboto\", sans-serif;\n  font-weight: 300;\n  margin: 0;\n}\n\ncode,\npre {\n  font-family: \"Roboto Mono\", monospace;\n}\n\nbutton {\n  border: 0;\n  padding: 0;\n  background: none;\n  border-radius: 0;\n  font-size: inherit;\n  font-family: inherit;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
